import {
	useCaptionOptions,
	useMediaPlayer,
	useMediaRemote,
	useMediaState,
} from '@vidstack/react'
import { SubtitlesIcon } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

export function Captions() {
	const player = useMediaPlayer()
	const options = useCaptionOptions()
	const hint = options.selectedTrack?.label ?? 'Off'

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant='ghost'
					size='icon'
					aria-label='Settings'
					disabled={options.disabled}
				>
					<SubtitlesIcon className='h-7 w-7' />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent collisionBoundary={player?.el}>
				<DropdownMenuLabel className='mb-2 flex w-full items-center px-1.5 text-[15px] font-medium'>
					<SubtitlesIcon className='mr-1.5 h-5 w-5 translate-y-px' />
					Captions
					<span className='ml-auto text-sm text-white/50'>{hint}</span>
				</DropdownMenuLabel>
				<DropdownMenuRadioGroup value={options.selectedValue}>
					{options.map(({ label, value, select }) => (
						<DropdownMenuRadioItem value={value} onSelect={select} key={value}>
							{label}
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
export function Quality() {
	const quality = useMediaState('quality')
	const qualityOptions = useMediaState('qualities')
	const player = useMediaPlayer()
	const options = qualityOptions || []
	const remote = useMediaRemote()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant='ghost'>{quality?.height}p</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent collisionBoundary={player?.el}>
				<DropdownMenuRadioGroup value={quality?.height?.toString()}>
					{options.map(({ height }, i) => (
						<DropdownMenuRadioItem
							value={height.toString()}
							onSelect={() => remote.changeQuality(i)}
							key={height}
						>
							{height}p
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
